import { render, staticRenderFns } from "./booking-search-controls.vue?vue&type=template&id=3054c7ff&scoped=true&"
import script from "./booking-search-controls.vue?vue&type=script&lang=js&"
export * from "./booking-search-controls.vue?vue&type=script&lang=js&"
import style0 from "./booking-search-controls.vue?vue&type=style&index=0&id=3054c7ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3054c7ff",
  null
  
)

export default component.exports